import Api from '../../services/Api';

const getDepartamentos = async () => {
    const request = await Api.get('/gestao/departamento'),
        list = request.data.data;

    return list;
};

const saveProduto = async (form) => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };

    return Api.post('/gestao/produto', form, config)
        .then((response) => {
            const { data } = response;

            return data;
        })
        .catch((error) => {
            throw error;
        });
};

const postImage = async ({ form, idProduto }) => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };

    return Api.post(`/gestao/produto/${idProduto}/imagem`, form, config)
        .then((response) => {
            const { data } = response;

            return data;
        })
        .catch((error) => {
            throw error;
        });
};

const getProductInfo = async ({ idProduto }) => {
    const { data } = await Api.get(`/gestao/produto/${idProduto}`);

    const lsProdutoImagem = data.data.lsProdutoImagem;

    if (lsProdutoImagem && lsProdutoImagem.length) {
        data.data.lsProdutoImagem = JSON.parse(lsProdutoImagem);
    }

    return data.data;
};
const deleteProductImage = async ({ idProduto, idProdutoImagem }) => {
    return Api.delete(`gestao/produto/${idProduto}/imagem/${idProdutoImagem}`);
};

export {
    getDepartamentos,
    saveProduto,
    postImage,
    getProductInfo,
    deleteProductImage
};
